import axios from "axios";
import { ensureValidToken, makeRequest, loginUser } from "../utils/handleJWT";

const SERVER_URL = `https://auth.umlang.com/auth/api/v1/auth`;

// تابع کمکی برای نرمال‌سازی شماره تلفن
export const normalizePhoneNumber = (phone) => {
  let cleaned = phone.replace(/\D/g, "");
  if (cleaned.startsWith("0")) {
    cleaned = cleaned.substring(1);
  }
  if (!cleaned.startsWith("98")) {
    cleaned = "98" + cleaned;
  }
  return cleaned;
};

// ============== APIهای بدون نیاز به توکن ==============

// ورود با اطلاعات کاربری
export const loginApi = async (loginInfo, password) => {
  const url = `${SERVER_URL}/login/`;
  try {
    const response = await axios.post(url, {
      loginInfo,
      password,
      device: "newWeb",
    });

    if (response.data?.success && response.data?.token) {
      loginUser(
        response.data.token,
        response.data.refreshToken,
        response.data.data?.data?.[0]
      );
    }

    return response;
  } catch (error) {
    throw error;
  }
};

// ثبت نام مرحله 1 - ارسال کد به شماره
export const registerStep1Api = async (phoneNumber) => {
  const normalizedPhone = normalizePhoneNumber(phoneNumber);
  const url = `${SERVER_URL}/register/step1`;

  try {
    const response = await axios.post(url, {
      phoneNumber: normalizedPhone,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// ثبت نام مرحله 2 - تایید کد
export const registerStep2Api = async (phoneNumber, confirmCode) => {
  const normalizedPhone = normalizePhoneNumber(phoneNumber);
  const url = `${SERVER_URL}/register/step2`;

  try {
    const response = await axios.post(url, {
      phoneNumber: normalizedPhone,
      confirmCode,
      device: "newWeb",
    });

    if (response.data?.success && response.data?.token) {
      loginUser(
        response.data.token,
        response.data.refreshToken,
        response.data.data?.data?.[0]
      );
    }

    return response;
  } catch (error) {
    throw error;
  }
};

// فراموشی رمز مرحله 1 - ارسال کد
export const forgotPasswordStep1Api = async (phoneNumber) => {
  const normalizedPhone = normalizePhoneNumber(phoneNumber);
  const url = `${SERVER_URL}/login/codestep1`;

  try {
    const response = await axios.post(url, {
      phoneNumber: normalizedPhone,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// فراموشی رمز مرحله 2 - تایید کد
export const forgotPasswordStep2Api = async (phoneNumber, confirmCode) => {
  const normalizedPhone = normalizePhoneNumber(phoneNumber);
  const url = `${SERVER_URL}/login/codestep2`;

  try {
    const response = await axios.post(url, {
      phoneNumber: normalizedPhone,
      confirmCode,
      device: "newWeb",
    });

    if (response.data?.success && response.data?.token) {
      loginUser(
        response.data.token,
        response.data.refreshToken,
        response.data.data?.data?.[0]
      );
    }

    return response;
  } catch (error) {
    throw error;
  }
};

// تایید توکن گوگل با بک‌اند (API یکپارچه جدید)
export const verifyGoogleApi = async (token, action) => {
  const url = `${SERVER_URL}/register/verify-google`;

  try {
    const response = await axios.post(url, {
      token,
      action,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// دریافت توکن پس از بازگشت از گوگل
export const getRegisterTokenApi = async (rtoken) => {
  const url = `${SERVER_URL}/login/getregistertoken`;

  try {
    const response = await axios.post(
      url,
      {
        rtoken,
        device: "newWeb",
      },
      {
        headers: {
          Authorization: `Bearer ${rtoken}`,
        },
      }
    );

    if (response.data?.success && response.data?.token) {
      loginUser(
        response.data.token,
        response.data.refreshToken,
        response.data.data?.data?.[0]
      );
    }

    return response;
  } catch (error) {
    throw error;
  }
};

// ============== APIهای نیازمند توکن ==============

// ثبت نام مرحله 3 - تنظیم رمز عبور
export const setPasswordApi = async (userPassword, confirmUserPassword) => {
  return makeRequest(async () => {
    // قبل از درخواست، توکن رو چک کن
    await ensureValidToken();

    const token = localStorage.getItem("token");
    const url = `${SERVER_URL}/register/step3`;

    const response = await axios.post(
      url,
      {
        userPassword,
        confirmUserPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  });
};

// تغییر رمز عبور
export const changePasswordApi = async (userPassword, confirmUserPassword) => {
  return makeRequest(async () => {
    await ensureValidToken();

    const token = localStorage.getItem("token");
    const url = `${SERVER_URL}/register/changepassword`;

    const response = await axios.post(
      url,
      {
        userPassword,
        confirmUserPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  });
};

// بررسی اعتبار نام کاربری
export const checkUsernameValidApi = async (newUsername) => {
  return makeRequest(async () => {
    await ensureValidToken();

    const token = localStorage.getItem("token");
    const url = `${SERVER_URL}/register/checkusernamevalid`;

    const response = await axios.post(
      url,
      {
        newUsername,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  });
};

// تغییر نام کاربری
export const changeUsernameApi = async (newUsername) => {
  return makeRequest(async () => {
    await ensureValidToken();

    const token = localStorage.getItem("token");
    const url = `${SERVER_URL}/register/changeusername`;

    const response = await axios.post(
      url,
      {
        newUsername,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // اگه نام کاربری با موفقیت تغییر کرد، اطلاعات رو به‌روز کن
    if (response.data?.success) {
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      userData.userName = newUsername;
      localStorage.setItem("userData", JSON.stringify(userData));
    }

    return response;
  });
};

// دریافت اطلاعات کاربر
export const getUserInfoApi = async () => {
  return makeRequest(async () => {
    await ensureValidToken();

    const token = localStorage.getItem("token");
    const url = `${SERVER_URL}/register/userinfo`;

    const response = await axios.post(
      url,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data?.success && response.data?.data?.data?.[0]) {
      localStorage.setItem(
        "userData",
        JSON.stringify(response.data.data.data[0])
      );
    }

    return response;
  });
};

// تغییر شماره همراه نامعتبر - مرحله 1 (ارسال کد)
export const changeInvalidPhoneNumberStep1Api = async (phoneNumber) => {
  return makeRequest(async () => {
    await ensureValidToken();

    const token = localStorage.getItem("token");
    const url = `${SERVER_URL}/register/changeInvalidPhonenumber`;

    const response = await axios.post(
      url,
      {
        phoneNumber,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  });
};

// تغییر شماره همراه نامعتبر - مرحله 2 (تایید کد)
export const changeInvalidPhoneNumberStep2Api = async (
  phoneNumber,
  confirmCode
) => {
  return makeRequest(async () => {
    await ensureValidToken();

    const token = localStorage.getItem("token");
    const url = `${SERVER_URL}/register/changeInvalidPhonenumber`;

    const response = await axios.post(
      url,
      {
        phoneNumber,
        confirmCode,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // به‌روزرسانی اطلاعات کاربر در localStorage
    if (response.data?.success) {
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      userData.phoneNumber = phoneNumber;
      localStorage.setItem("userData", JSON.stringify(userData));
    }

    return response;
  });
};
// حذف حساب کاربری
export const deleteAccountApi = async () => {
  return makeRequest(async () => {
    await ensureValidToken();

    const token = localStorage.getItem("token");
    const url = `${SERVER_URL}/login/deleteAccount`;

    const response = await axios.post(
      url,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  });
};

// ثبت کد معرف
export const setReferralCodeApi = async (registerCode) => {
  return makeRequest(async () => {
    await ensureValidToken();

    const token = localStorage.getItem("token");
    const url = `${SERVER_URL}/register/setReferralCode`;

    const response = await axios.post(
      url,
      {
        registerCode,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // به‌روزرسانی اطلاعات کاربر در localStorage
    if (response.data?.success) {
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      userData.presenterCode = registerCode;
      localStorage.setItem("userData", JSON.stringify(userData));
    }

    return response;
  });
};
